import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import Delete from '@mui/icons-material/Delete';

import { colTablePermission } from '../../../helpers/tableConfigs';
import { useDataAuth } from '../../../hooks/useDataAuth';

export const TablePermissionsUsers = ({ isLoadingPermissions, listAllPermissions, DeletePermission, t }) => {
    const [{ userSession }] = useDataAuth();
    const DeleteReg = (idUsAccess) => {
        DeletePermission(userSession.token, idUsAccess);
    }

    return (
        <TableContainer
            style={{ height: '35vh', overflow: 'auto', borderBottom: 'solid 1px' }}
        >
            <Table
                aria-labelledby='tableTitle'
                size='small'
                stickyHeader
            >
                <TableHead>
                    <TableRow sx={{ px: 2 }}>
                        <TableCell
                            align='center'
                            style={{ width: 30 }}
                        >
                        </TableCell>
                        <TableCell
                            align='center'
                            style={{ width: 30 }}
                        >
                            {t('user.permission')}
                        </TableCell>
                        <TableCell
                            align='center'
                            style={{ width: 30 }}
                        >
                            {t('user.company')}
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {
                        isLoadingPermissions ? (
                            <TableRow sx={{ height: 150, py: 2 }}>
                                <TableCell
                                    colSpan={colTablePermission.length + 2}
                                    align='center'
                                >
                                    <CircularProgress
                                        color='primary'
                                    />
                                </TableCell>
                            </TableRow>
                        ) : !isLoadingPermissions && !listAllPermissions.length > 0 ? (
                            <TableRow sx={{ height: 150, py: 2 }}>
                                <TableCell
                                    colSpan={colTablePermission.length + 2}
                                    align='center'
                                >
                                    <Typography>{t("messages.noRecords")}</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            listAllPermissions.map((item, cont) => (
                                <TableRow
                                    tabIndex={cont}
                                    key={item.id_user_access}
                                >
                                    <TableCell align='center'>
                                        <Tooltip title={t("delete")}>
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => DeleteReg(item.id_user_access)}
                                                sx={{ color: 'red' }}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                    {colTablePermission.map((col, index) => (
                                        col.visible &&
                                        <TableCell
                                            key={`tc-${index}`}
                                            padding='normal'
                                            align='center'
                                        >
                                            <Typography>
                                                {item[col.id]}
                                            </Typography>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        )
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
}
